Greenmile.Survey.Sidebar.SIGNATURE = function () {

  this.resourceKey = 'Signature';
  this.jsonType = 'SIGNATURE';
  this.hideDefaultAnswer = true;
  this.hideAnswerInput = true;

  Greenmile.Survey.Sidebar.Generic.apply(this, arguments);
};